import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import SahamDialog from 'components/SahamDialog';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskAmount/messages';
import { numberWithCommas } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import { get, isEmpty, isNil } from 'lodash';
import { Grid, TextField } from '@material-ui/core';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { JUDICIARY_TYPE } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { REGULATION_AMOUNTS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';

export interface DialogProps {
  intl: IntlShape;
  open: boolean;
  handleClose: Function;
  handleValidate: any;
  item: any;
  riskRecap: RcCorporeal[];
  setRiskRecap: Function;
  openDialogValidation: any;
  handleChange: Function;
  rcCorporeal: RcCorporeal;
  disabled: boolean;
  title: any;
  isBasicManagementRegulation?: boolean;
}

const Dialog: React.FC<DialogProps> = (props): JSX.Element => {
  //more readable
  const isFirstInstance =
    get(props.openDialogValidation[props.item?.id], 'type') ===
    JUDICIARY_TYPE.FIRST_INSTANCE;
  const isAppeal =
    get(props.openDialogValidation[props.item?.id], 'type') ===
    JUDICIARY_TYPE.APPEAL;
  const hasNextOfKinKey = !isNil(get(props.item, 'nextOfKinKey'));

  const isCompensationAmountEmpty = isEmpty(
    get(props.item, 'regulationAmount.compensationAmount', ''),
  );
  const isAppealAmountEmpty = isEmpty(
    get(props.item, 'regulationAmount.appealAmount', ''),
  );
  const isJudgementAmountEmpty = isEmpty(
    get(props.item, 'jomBeneficiary.judgementAmount', ''),
  );
  const isAppealBeneficiaryAmountEmpty = isEmpty(
    get(props.item, 'appealBeneficiary.judgementAmount', ''),
  );

  const shouldDisableReason =
    props.isBasicManagementRegulation &&
    ((isCompensationAmountEmpty && isFirstInstance && !hasNextOfKinKey) ||
      (isAppealAmountEmpty && isAppeal && !hasNextOfKinKey) ||
      (isJudgementAmountEmpty && isFirstInstance && hasNextOfKinKey) ||
      (isAppealBeneficiaryAmountEmpty && isAppeal && hasNextOfKinKey));

  return (
    <SahamDialog
      handleValidate={props.handleValidate}
      handleClose={props.handleClose as any}
      title={props.title}
      cancelTitle={translate(messages.cancelButton, props)}
      confirmTitle={translate(messages.confirmationButton, props)}
      open={props.open}
      validateButtonDisabled={props.disabled}
    >
      <div>
        {get(props.openDialogValidation[props.item?.id], 'type') ===
          JUDICIARY_TYPE.FIRST_INSTANCE &&
        isNil(get(props.item, 'nextOfKinKey')) ? (
          <Grid container direction="column">
            <TextField
              fullWidth
              label={translate(messages.judgementCompensationAmount, props)}
              name={REGULATION_AMOUNTS.COMPENSATION_AMOUNT}
              id={REGULATION_AMOUNTS.COMPENSATION_AMOUNT}
              value={numberWithCommas(
                String(
                  get(props.item, 'regulationAmount.compensationAmount', ''),
                ),
              )}
              style={{ marginBottom: '10px' }}
              onChange={props.handleChange(props.rcCorporeal, props.item)}
            />
            <TextField
              fullWidth
              label={translate(messages.reason, props)}
              value={get(props.item, 'regulationAmount.judgementReason', '')}
              name={REGULATION_AMOUNTS.JUDGEMENT_REASON}
              onChange={props.handleChange(props.rcCorporeal, props.item)}
              disabled={shouldDisableReason}
            />
          </Grid>
        ) : (
          get(props.openDialogValidation[props.item?.id], 'type') ===
            JUDICIARY_TYPE.APPEAL &&
          isNil(get(props.item, 'nextOfKinKey')) && (
            <Grid container direction="column">
              <Grid item spacing={1}>
                <TextField
                  fullWidth
                  label={translate(messages.appealCompensationAmount, props)}
                  name={REGULATION_AMOUNTS.APPEAL_AMOUNT}
                  onChange={props.handleChange(props.rcCorporeal, props.item)}
                  value={numberWithCommas(
                    String(
                      get(props.item, 'regulationAmount.appealAmount', ''),
                    ),
                  )}
                  style={{ marginBottom: '10px' }}
                />
              </Grid>
              <Grid item spacing={2}>
                <TextField
                  fullWidth
                  label={translate(messages.reason, props)}
                  value={get(props.item, 'regulationAmount.appealReason', '')}
                  name={REGULATION_AMOUNTS.APPEAL_REASON}
                  onChange={props.handleChange(props.rcCorporeal, props.item)}
                  disabled={shouldDisableReason}
                />
              </Grid>
            </Grid>
          )
        )}
        {get(props.openDialogValidation[props.item?.id], 'type') ===
          JUDICIARY_TYPE.FIRST_INSTANCE &&
        !isNil(get(props.item, 'nextOfKinKey')) ? (
          <Grid container direction="column">
            <TextField
              fullWidth
              label={translate(messages.judgementCompensationAmount, props)}
              name={REGULATION_AMOUNTS.JUDGEMENT_AMOUNT}
              data-testid={REGULATION_AMOUNTS.JUDGEMENT_AMOUNT}
              value={numberWithCommas(
                String(get(props.item, 'jomBeneficiary.judgementAmount', '')),
              )}
              style={{ marginBottom: '10px' }}
              onChange={props.handleChange(props.item, 'jomBeneficiary')}
            />
            <TextField
              fullWidth
              label={translate(messages.reason, props)}
              value={get(props.item, 'jomBeneficiary.judgementReason', '')}
              name={REGULATION_AMOUNTS.JUDGEMENT_REASON}
              onChange={props.handleChange(props.item, 'jomBeneficiary')}
              disabled={shouldDisableReason}
            />
          </Grid>
        ) : (
          get(props.openDialogValidation[props.item?.id], 'type') ===
            JUDICIARY_TYPE.APPEAL &&
          !isNil(get(props.item, 'nextOfKinKey')) && (
            <Grid container direction="column">
              <Grid item spacing={1}>
                <TextField
                  fullWidth
                  label={translate(messages.appealCompensationAmount, props)}
                  name={REGULATION_AMOUNTS.JUDGEMENT_AMOUNT}
                  onChange={props.handleChange(props.item, 'appealBeneficiary')}
                  value={numberWithCommas(
                    String(
                      get(props.item, 'appealBeneficiary.judgementAmount', ''),
                    ),
                  )}
                  style={{ marginBottom: '10px' }}
                />
              </Grid>
              <Grid item spacing={2}>
                <TextField
                  fullWidth
                  label={translate(messages.reason, props)}
                  value={get(props.item, 'appealBeneficiary.appealReason', '')}
                  name={REGULATION_AMOUNTS.APPEAL_REASON}
                  onChange={props.handleChange(props.item, 'appealBeneficiary')}
                  disabled={shouldDisableReason}
                />
              </Grid>
            </Grid>
          )
        )}
      </div>
    </SahamDialog>
  );
};

export default injectIntl(Dialog);
